import { Component, EventEmitter, Input, Output } from '@angular/core';

import { HeaderLogoComponent } from '../header-logo/header-logo.component';
import { ButtonComponent } from '../buttons/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-maintenance-template',
  templateUrl: './maintenance-template.component.html',
  imports: [HeaderLogoComponent, ButtonComponent, TranslatePipe],
})
export class MaintenanceTemplateComponent {
  @Input() headline: string;
  @Input() subheadline: string;
  @Input() text: string;
  @Input() isBtnVisible = true;
  @Input() buttonLabelkey: string;
  @Input() isHeaderLogoVisible = false;
  @Output() buttonClick = new EventEmitter<void>();
}
